import React, { useState } from 'react';
import { Box } from '@mui/material';
import AppShell from '../components/Layout/AppShell';
import GridProcessos from '../components/Processos/GridProcessos';
import MenuLateralProcesso from '../components/Processos/MenuLateralProcesso';
import BarraAcoesProcesso from '../components/Processos/BarraAcoesProcesso';
import AbaAcompanhamento from '../components/Processos/abas/AbaAcompanhamento';
import AbaHistorico from '../components/Processos/abas/AbaHistorico';
import AbaRecebimento from '../components/Processos/abas/AbaRecebimento';
import AbaFinanceira from '../components/Processos/abas/AbaFinanceira';
import AbaDocumentos from '../components/Processos/abas/AbaDocumentos';
import AbaEmail from '../components/Processos/abas/AbaEmail';
import AbaDevedor from '../components/Processos/abas/AbaDevedor';
import AbaCliente from '../components/Processos/abas/AbaCliente';
import AbaRecalculos from '../components/Processos/abas/AbaRecalculos';
import AbaJuridico from '../components/Processos/abas/AbaJuridico';
import AbaFases from '../components/Processos/abas/AbaFases';
import { PROCESSOS } from '../mocks/processos.mock';

/**
 * Controle de Processos.
 *
 * Estrutura em três faixas horizontais, como nos prints:
 *   [ grid redimensionável ] [ painel de detalhe (flex) ] [ menu lateral direito ]
 *
 * A grid tem largura própria (estado interno, arrastável). O painel do meio é
 * `flex: 1` com `minWidth: 0` — esse `minWidth: 0` é o que permite ele encolher
 * quando a grid cresce; sem isso o flexbox usa o conteúdo como largura mínima e
 * o layout estoura para a direita.
 *
 * O menu lateral tem largura própria em `clamp()` e é `position: sticky`, então
 * acompanha o scroll das abas mais longas (Devedor, Cliente, Fases).
 */
export default function ControleProcessosPage() {
  const [processo, setProcesso] = useState(PROCESSOS[5]); // 3290185, o do print
  const [aba, setAba] = useState('acompanhamento');

  const renderAba = () => {
    switch (aba) {
      case 'historico': return <AbaHistorico processo={processo} />;
      case 'recebimento': return <AbaRecebimento processo={processo} />;
      case 'financeira': return <AbaFinanceira processo={processo} />;
      case 'documentos': return <AbaDocumentos />;
      case 'email': return <AbaEmail />;
      case 'devedor': return <AbaDevedor processo={processo} />;
      case 'cliente': return <AbaCliente processo={processo} />;
      case 'recalculos': return <AbaRecalculos />;
      case 'juridico': return <AbaJuridico />;
      case 'fases': return <AbaFases />;
      case 'acompanhamento':
      default: return <AbaAcompanhamento processo={processo} />;
    }
  };

  return (
    <AppShell titulo="Controle de processos" fullBleed>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 'clamp(14px, 0.9vw, 26px)',
          flexWrap: { xs: 'wrap', lg: 'nowrap' },
        }}
      >
        <GridProcessos selecionado={processo} onSelecionar={setProcesso} />

        {/* minWidth: 0 é essencial — ver comentário no topo do arquivo. */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <BarraAcoesProcesso />
          {renderAba()}
        </Box>

        <MenuLateralProcesso ativo={aba} onChange={setAba} />
      </Box>
    </AppShell>
  );
}
